module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-screen-operation-area.d1747a62.png";